module.exports = __webpack_public_path__ + "static/img/copper-ore_256.71005d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copper-ore_256.png
// module id = lY0u
// module chunks = 0